module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921075651_T.e28f030c.jpg";